import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

// Remove Emergent badge
(function removeBadge() {
  const kill = () => {
    const el = document.getElementById('emergent-badge');
    if (el) el.remove();
  };
  kill();
  setInterval(kill, 100);
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
